import React, { useEffect } from 'react';
import { LogOutIcon, UserIcon, Pane, PropertiesIcon, CogIcon, ProjectsIcon, ShoppingCartIcon, Pill, Menu, Popover, Button, MenuIcon, Positioner, Text } from "evergreen-ui";
import { useNavigate } from "react-router-dom";
import { useCart } from './Cart';
import { useAPI } from './Api';
import img from './assets/logo_transparent_background.png';
import { SideButton } from './App';

export let AppFrame = (props) => {
  let navigate = useNavigate();

  let API = useAPI();


  let Cart = useCart();
  let isAdmin = API.isAdmin;

  return <Pane style={{ height: "100%", width: "100%" }}>
    {props.isAuth && <Pane display="flex" background="blueTint">
      <img src={img} height={64} style={{ marginRight: '24px' }} />


      {/* This is the menu hamburger once the screen sizes goes to 1080px (width) or under */}
      <Pane className="miniMenu" display="flex" borderRadius={3} flexDirection={"row"} justifyContent={"right"} alignItems={"center"} width="100%">
        <SideButton onClick={() => {
          if (props.order) { props.selectOrder(null); }
          navigate('/projects');
          props.setOrder(null);
        }}
          key="Library" background="#206BE1" color="white">

          <ProjectsIcon size={20} /> <Text color="white" size={600}><strong>Projects-</strong></Text>
        </SideButton>

        <SideButton onClick={() => { navigate('/cart'); }}
          key="cart" background="#206BE1" color="white">

          <ShoppingCartIcon size={20} /> <Text color="white" size={600}><strong>Cart</strong></Text>

          {Cart.count > 0 && <Pill style={{ float: 'right' }} margin={4}>
            {Cart.count}
          </Pill>}
        </SideButton>

        <Popover
          content={
            <Menu>
              <Menu.Group>

                <SideButton onClick={() => { navigate('/orders'); }}
                  key="Orders" background="#206BE1" color="white">

                  <PropertiesIcon size={20} /> <Text color="white" size={600}><strong>Orders</strong></Text>
                </SideButton>

                <SideButton
                  key="profile" background="#206BE1" color="white" onClick={() => {
                    var win = window.open('https://duraproducts.com.au/account/', '_blank');
                    win.focus();
                  }}>
                  <UserIcon size={20} /> <Text color="white" size={600}><strong>Profile</strong></Text>
                </SideButton>

                {isAdmin &&
                  <SideButton onClick={() => { navigate('/admin'); }}
                    key="proAdminfile" background="#206BE1" color="white">

                    <CogIcon size={20} /> <Text color="white" size={600}><strong>Admin</strong></Text>
                  </SideButton>}
              </Menu.Group>
              <Menu.Divider />
              <Menu.Group>
                <SideButton
                  key="logout" background="#206BE1" color="white" onClick={() => { API.logout(); }}>
                  <LogOutIcon size={20} /> <Text color="white" size={600}><strong>Log out</strong></Text>
                </SideButton>
              </Menu.Group>
            </Menu>
          }
        >
          <Button marginRight={16}><MenuIcon /></Button>
        </Popover>
      </Pane>

      {/* This is the normal menu when the screen is >1164px (width) */}
      <Pane className="largeMenu" display="flex" padding={8} borderRadius={3} style={{ width: "100%" }}>
        <Pane flex={1} alignItems="center" display="flex" justifyContent={"right"}>
          <SideButton onClick={() => {
            if (props.order) { props.selectOrder(null); }
            navigate('/projects');
            props.setOrder(null);
          }}
            key="Library" background="#206BE1" color="white">
            <ProjectsIcon size={20} marginRight={8} /> <Text color="white" size={600}><strong>Projects</strong></Text>
          </SideButton>

          <SideButton onClick={() => { navigate('/orders'); }}
            key="Orders" background="#206BE1" color="white">
            <PropertiesIcon size={20} marginRight={8} /> <Text color="white" size={600}><strong>Orders</strong></Text>
          </SideButton>

          <SideButton onClick={() => { navigate('/cart'); }}
            key="cart" background="#206BE1" color="white">
            <ShoppingCartIcon size={20} marginRight={8} /><Text color="white" size={600}><strong>Cart</strong></Text>
            {Cart.count > 0 && <Pill style={{ float: 'right' }} margin={4}>
              {Cart.count}
            </Pill>}
          </SideButton>
        </Pane>

        <Pane display="flex">
          <SideButton
            key="profile" background="#206BE1" color="white" onClick={() => {
              var win = window.open('https://duraproducts.com.au/account/', '_blank');
              win.focus();
            }}>
            <UserIcon size={20} marginRight={8} /> <Text color="white" size={600}><strong>Profile</strong></Text>
          </SideButton>

          {isAdmin &&
            <SideButton onClick={() => { navigate('/admin'); }}
              key="proAdminfile" background="#206BE1" color="white">
              <CogIcon size={20} marginRight={8} /> <Text color="white" size={600}><strong>Admin</strong></Text>
            </SideButton>}
        </Pane>

        <SideButton
          key="logout" background="#206BE1" color="white" onClick={() => { API.logout(); }}>
          <LogOutIcon size={20} marginRight={8} /> <Text color="white" size={600}><strong>Log out</strong></Text>
        </SideButton>
      </Pane>
    </Pane>}

    <Pane display="flex" flex={2} style={{ minHeight: "100%", maxHeight: "100%" }} overflow={"auto"}>
      {props.children}
    </Pane>
  </Pane>;
};
